import {Box, HBox} from '../../../../../src/components/core/view';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import AddDeliveryPhotoCell from '../addDeliveryPhotoCell';
import AddSignatureCell from '../addSignatureCell';
import {DeliveryLocationDetails} from '../../../../../src/driver/types/deliveryDetails';
import {H6Text} from '@buncha/components/core/text';
import {HomeScreens} from '@buncha/home/navigation/types';
import If from '../../../../../src/components/conditional/If';
import {Modules} from '@buncha/utils/types';
import React from 'react';
import {StyleSheet} from 'react-native';
import VerifyBarcodesCell from '../verifyBarcodesCell';
import VerifyIdCell from '../verifyIdCell';
import {useAppSelector} from '@buncha/config/redux/hooks';
import {useDeliveryDetailsContext} from '@buncha/driver/hooks/deliveryDetails';
import {useGetLocale} from '@buncha/localization/hooks';

interface PhotoAndSignatureComponentProps {
  orderId: string;
  deliveryLocationData: DeliveryLocationDetails | undefined;
  containsAlcoholicItems: boolean;
  runId: number;
  bagsUsed?: number;
  customerName?: string;
  taskId?: string;
}

const PhotoAndSignatureComponent: React.FC<
  PhotoAndSignatureComponentProps
> = props => {
  const {state} = useDeliveryDetailsContext();
  const muli = useFontTheme('muli');
  const theme = useColorThemeType();
  const {title} = useGetLocale(Modules.driver, HomeScreens.Driver) ?? {};
  const deliveryLocationData = props?.deliveryLocationData;
  const signatureUrl =
    (state.signatureImage || deliveryLocationData?.signature) ?? '';
  const deliveryLocationId = deliveryLocationData?.id ?? 0;
  const containsAlcoholicItems = props?.containsAlcoholicItems || false;

  const currentTaskId = props?.taskId;

  const currentTask = useAppSelector(gState => gState.home.driverTasks)?.find(
    task => task.id === currentTaskId,
  );

  return (
    <Box style={styles.mainBox}>
      <H6Text
        style={{
          color: theme?.text?.blue?.[300],
          fontFamily: muli?.[700]?.normal,
        }}>
        {title?.attachments}
      </H6Text>
      <HBox style={styles.parentBox}>
        <AddDeliveryPhotoCell
          orderId={props?.orderId}
          deliveryLocationId={deliveryLocationId}
          runId={props?.runId}
          isRequired={currentTask?.photoRequired}
          bagsUsed={props?.bagsUsed}
          customerName={props?.customerName}
        />
        <AddSignatureCell
          orderId={props?.orderId}
          signatureUrl={signatureUrl}
          runId={props?.runId}
          isRequired={currentTask?.signatureRequired}
          taskId={currentTask?.id ?? ''}
        />
        <If condition={containsAlcoholicItems}>
          <VerifyIdCell
            orderId={props?.orderId}
            runId={props?.runId}
            minimumAge={currentTask?.minimumAge}
          />
        </If>
        <If condition={currentTask?.barcodes?.length}>
          <VerifyBarcodesCell requestedBarcodes={currentTask?.barcodes ?? []} />
        </If>
      </HBox>
    </Box>
  );
};

export default React.memo(PhotoAndSignatureComponent);

const styles = StyleSheet.create({
  parentBox: {
    marginTop: 15,
    alignItems: 'stretch',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    rowGap: 5,
    columnGap: 5,
  },
  mainBox: {alignItems: 'flex-start', marginTop: 15},
});
